import React from 'react';
import { Construction } from 'lucide-react';

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title, description = 'Esta página está em desenvolvimento.' }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <div className="w-24 h-24 bg-gradient-to-br from-yellow-400 to-orange-500 dark:from-yellow-500 dark:to-orange-600 rounded-full flex items-center justify-center mb-6">
        <Construction className="w-12 h-12 text-white" />
      </div>
      
      <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">
        {title}
      </h1>
      
      <p className="text-lg text-gray-600 dark:text-gray-400 max-w-md mb-8">
        {description}
      </p>
      
      <div className="bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900/30 dark:to-orange-900/30 border border-yellow-200 dark:border-yellow-700/50 rounded-lg p-6 max-w-md">
        <h3 className="font-semibold text-yellow-800 dark:text-yellow-300 mb-2">
          🚧 Em Construção
        </h3>
        <p className="text-sm text-yellow-700 dark:text-yellow-400">
          Esta funcionalidade será implementada em breve. 
          O sistema está sendo desenvolvido com TypeScript e integração completa com o backend.
        </p>
      </div>
    </div>
  );
};

export default PlaceholderPage;
